import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type IsBundleMaintClaimType = string | string[];
export type IsBundleMaintClaimArgs = {};

export const ruleBundleMaint: SecurityRuleFactory<IsBundleMaintClaimType, IsBundleMaintClaimArgs> =
  createSimpleClaimRule<IsBundleMaintClaimType, IsBundleMaintClaimArgs>("bundle-maint");

